import { apiRequest, getAdpApiClient } from '../api/client';
import type {
  DownloadFileLink,
  S3LinksData,
  S3LinksRequest,
} from './download.types';

function downloadBlob(blob: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
}

export const downloadService = {
  fetchS3Links: async (params: S3LinksRequest): Promise<DownloadFileLink[]> => {
    const data = await apiRequest<S3LinksData>(
      {
        method: 'POST',
        url: '/downloads/s3-links',
        data: params,
      },
      'Failed to fetch download links'
    );

    return data.files;
  },

  downloadS3File: async (signedToken: string, fileName: string): Promise<void> => {
    const response = await getAdpApiClient().request<Blob>({
      method: 'GET',
      url: '/downloads/s3-file',
      params: {
        signed_token: signedToken,
      },
      responseType: 'blob',
      headers: {
        Accept: '*/*',
      },
    });

    downloadBlob(response.data, fileName);
  },

  downloadDQReport: async (dataFlowId: string): Promise<void> => {
    const files = await downloadService.fetchS3Links({
      download_request_type: 'dq_failed_records_download',
      data_flow_id: Number(dataFlowId),
    });

    if (!files.length) {
      throw new Error('No files available for download');
    }

    await Promise.all(
      files.map((file) => downloadService.downloadS3File(file.signed_token, file.file_name))
    );
  },

  downloadDestinationFile: async (
    folderName: string,
    targetTableId: number
  ): Promise<void> => {
    const files = await downloadService.fetchS3Links({
      download_request_type: 'destination_file_download',
      folder_name: folderName,
      target_table_id: targetTableId,
    });

    if (!files.length) {
      throw new Error('No files available for download');
    }

    await Promise.all(
      files.map((file) => downloadService.downloadS3File(file.signed_token, file.file_name))
    );
  },
};

export default downloadService;
